<img
  [ngClass]="[logoClasses]"
  (click)="goHome()"
  src="assets/svg/logo-v2.svg"
/>
